import { render, staticRenderFns } from "./wine-sales-product-performance.vue?vue&type=template&id=f4970658&scoped=true&"
import script from "./wine-sales-product-performance.vue?vue&type=script&lang=js&"
export * from "./wine-sales-product-performance.vue?vue&type=script&lang=js&"
import style0 from "./wine-sales-product-performance.vue?vue&type=style&index=0&id=f4970658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4970658",
  null
  
)

export default component.exports